import store from '../redux/store';
import { getVisibleStorePhone } from './getContactDetails';

export function rejectPayNowPaymentMethodReceivedMsg() {
  const storeData = store?.getState()?.storeReducer?.store;
  return `You cannot pay at the moment. Please contact us: 
  ${getVisibleStorePhone(storeData)}`;
}
